<template>
  <div>
    <div ref="quillContainer" />
    <InputError :message="error" class="mt-2" />
  </div>
</template>

<script setup>
import { ref, watch, onMounted, onBeforeUnmount } from "vue";
import InputError from "@/Components/InputError.vue";
import Quill from "quill";
import "quill/dist/quill.snow.css";
import Swal from "sweetalert2";

const props = defineProps({
  modelValue: String,
  error: String,
});
const emit = defineEmits(["update:modelValue"]);

const quillContainer = ref(null);
let quill = null;

function imageHandler() {
  const input = document.createElement("input");
  input.setAttribute("type", "file");
  input.setAttribute("accept", "image/*");
  input.click();
  input.onchange = async () => {
    const file = input.files[0];
    if (!file) return;
    const formData = new FormData();
    formData.append("image", file);
    try {
      const csrf = document
        .querySelector('meta[name="csrf-token"]')
        ?.getAttribute("content");
      const response = await fetch("/berita/upload-image", {
        method: "POST",
        body: formData,
        headers: csrf ? { "X-CSRF-TOKEN": csrf } : {},
      });
      const data = await response.json();
      const url = data.url || data.path || data.location;
      if (url) {
        const range = quill.getSelection();
        quill.insertEmbed(range.index, "image", url);
      }
    } catch (e) {
      Swal.fire({
        title: "Gagal!",
        text: "Gagal upload gambar.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };
}

onMounted(() => {
  quill = new Quill(quillContainer.value, {
    theme: "snow",
    modules: {
      toolbar: {
        container: [
          ["bold", "italic", "underline", "strike"],
          ["blockquote", "code-block"],
          [{ header: 1 }, { header: 2 }],
          [{ list: "ordered" }, { list: "bullet" }],
          [{ script: "sub" }, { script: "super" }],
          [{ indent: "-1" }, { indent: "+1" }],
          [{ direction: "rtl" }],
          [{ size: ["small", false, "large", "huge"] }],
          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          [{ color: [] }, { background: [] }],
          [{ font: [] }],
          [{ align: [] }],
          ["link", "image", "video"],
          ["clean"],
        ],
        handlers: {
          image: imageHandler,
        },
      },
    },
    placeholder: "Tulis konten berita di sini...",
  });
  quill.root.innerHTML = props.modelValue || "";
  quill.on("text-change", () => {
    emit("update:modelValue", quill.root.innerHTML);
  });
});

watch(
  () => props.modelValue,
  (val) => {
    if (quill && val !== quill.root.innerHTML) {
      quill.root.innerHTML = val || "";
    }
  }
);

onBeforeUnmount(() => {
  quill = null;
});
</script>

<style scoped>
.ql-container {
  min-height: 200px;
  border-radius: 0.75rem;
  background: #fff;
}
</style>
